import { env } from '@/infra/env'

/**
 * Sends the browser to HQ's login, through the user's enterprise connection
 * when they have one.
 *
 * @param enterpriseConnection
 */
export function gotoHQ(enterpriseConnection: string | null) {
  const hqUrl = new URL(env.HQ_URL)
  hqUrl.searchParams.set('show', 'login')
  if (enterpriseConnection) {
    hqUrl.searchParams.set('connection', enterpriseConnection)
  }
  window.location.assign(hqUrl.toString())
}
